export function getInitialStateAgro() {
   return {
      formData: [],
      selectedPlan: '',
      cultivos: [],
      localidades: [],
      monedas: [],
      pagos: [],
      sumatoriaHectareas: null,
      formaPago: [],
      planes: [],
      companias: [],
      descuentos: null,
      coordDibujo: null,
      currentLote: null,
      monedaLiquidacion: null,
      resumenPorMonedaCultivo: {},
      provinciasCotizables: [],
      departamentosCotizables: {}, // { [id_provincia]: Departamento[] }
   };
}

export default getInitialStateAgro();
